import { LoadingOverlay } from "../../../components/Loading";
import { NotFound } from "../../../components/NotFound";
import { useAttachmentTicket } from "../../../services/tickets/useTickets";
import { useTicketStore } from "../../../store/ticket";
import { ModalViewAttachments } from "./ModalViewAttachments";



export type ModalViewAttachmentsContainerProps = {
    isOpen: boolean;
    onClose: () => void;
}


export const ModalViewAttachmentsContainer = ({ isOpen, onClose }: ModalViewAttachmentsContainerProps) => {

    const { ticket } = useTicketStore();

    const { data, isLoading, isError, error, refetch } = useAttachmentTicket(
        ticket!.numeroTopicoPreAtendimento,
        {
            enabled: !!ticket,
            staleTime: Infinity,
        }
    );


    return (
        <>
            {isError && (
                <NotFound
                    error={error}
                    defaultMessage={'Erro ao carregar os anexos do ticket.'}
                    retry={refetch}
                />
            )}

            {isLoading && <LoadingOverlay />}


            {data && ticket && <ModalViewAttachments
                isOpen={isOpen}
                attachmentFiles={data}
                onClose={onClose}
                ticket={ticket}
            />}
        </>
    );


}